// extracted by mini-css-extract-plugin
module.exports = {"cell":"Table_cell__35hRH","table":"Table_table__-z9t9","rowActions":"Table_rowActions__2QiJT","common":"Table_common__3eOcf"};